<div mat-dialog-title>
  <div class="d-flex align-items-center justify-content-between fs-16">
    <div>
      <i class="i-16 mr-8 fas fa-sync-alt fa-spin"></i>
      <span>Extended Dataset Progress</span>
    </div>
  </div>
</div>
<div mat-dialog-content class="text-center pb-16">
  <p class="c-grey-5 fs-14 ws-pre">Insights is processing the Extended Dataset that you have requested.</p>
  <!-- TODO: Use ngFor or template -->
  <div class="d-flex justify-content-evenly">
    <ng-container *ngTemplateOutlet="stage; context: { text: 'Connection', index: 0, spacer: true }"></ng-container>
    <ng-container *ngTemplateOutlet="stage; context: { text: 'Execution', index: 1, spacer: true }"></ng-container>
    <ng-container *ngTemplateOutlet="stage; context: { text: 'Data Transfer', index: 2, spacer: true }"></ng-container>
    <ng-container *ngTemplateOutlet="stage; context: { text: 'Final Preparation', index: 3, spacer: false }"></ng-container>
  </div>
</div>
<div *ngIf="data.allowCancel" mat-dialog-actions align="center" class="buttons-section m-0">
  <button trgButton color="red" class="min-w-100" (click)="cancelRefresh()" [disabled]="cancellationRequested()">
    {{ cancellationRequested() ? "Attempting to cancel..." : "Cancel" }}
  </button>
</div>

<ng-template #stage let-text="text" let-index="index" let-spacer="spacer">
  <div class="proggress-stage d-flex align-items-center"
       [class.in-proggress]="currentStage() == index"
       [class.finished]="currentStage() > index">
    <div class="bgc-white d-flex justify-content-center proggress-icon-frame" style="width: 60px; position: relative">
      <div class="proggress-icon d-flex justify-content-center">
        <span *ngIf="currentStage() <= index" class="fs-15 align-items-center d-flex bold">{{ index + 1 }}</span>
        <span *ngIf="currentStage() > index" class="fas fs-15 fa-check align-items-center d-flex c-white"></span>
      </div>
    </div>
    <span class="fs-12 pt-10 bold">{{ text }}</span>
  </div>
  <div *ngIf="spacer == true" class="proggress-spacer"
       [class.finished]="currentStage() > index"></div>
</ng-template>